const iconButtonTypeVariants = {
    primary: {},
    secondary: {},
    plainPrimary: {},
    plainSecondary: {},
    plainFavorite: {},
    penny: {},
    radialPrimary: {},
    radialSecondary: {}
};
const iconButtonTypes = Object.keys(iconButtonTypeVariants);
const iconButtonSizeVariants = {
    '3xs': {
        wrapperSlot: 'min-h-4 min-w-4',
        buttonSlot: 'after:-left-2 after:-top-2 after:w-8 after:h-8',
        tapSpaceSlot: '-left-2 -top-2 w-8 h-8',
        iconSlot: 'h-4 w-4'
    },
    '2xs': {
        wrapperSlot: 'min-h-5 min-w-5',
        buttonSlot: 'after:-left-2 after:-top-2 after:w-9 after:h-9',
        tapSpaceSlot: '-left-2 -top-2 w-9 h-9',
        iconSlot: 'h-5 w-5'
    },
    xs: {
        wrapperSlot: 'min-h-6 min-w-6',
        buttonSlot: 'after:-left-2 after:-top-2 after:w-10 after:h-10',
        tapSpaceSlot: '-left-2 -top-2 w-10 h-10',
        iconSlot: 'h-6 w-6'
    },
    sm: {
        wrapperSlot: 'min-h-8 min-w-8',
        buttonSlot: 'after:-left-1 after:-top-1 after:w-10 after:h-10',
        tapSpaceSlot: '-left-1 -top-1 w-10 h-10',
        iconSlot: 'h-6 w-6'
    },
    md: {
        wrapperSlot: 'min-h-10 min-w-10',
        buttonSlot: 'after:-left-1 after:-top-1 after:w-12 after:h-12',
        tapSpaceSlot: '-left-1 -top-1 w-12 h-12',
        iconSlot: 'h-6 w-6'
    },
    lg: {
        wrapperSlot: 'min-h-12 min-w-12',
        iconSlot: 'h-7 w-7'
    }
};
const iconButtonSizes = Object.keys(iconButtonSizeVariants);
const iconButtonEmphasisVariants = {
    regular: {},
    medium: {},
    bold: {}
};
const iconButtonEmphases = Object.keys(iconButtonEmphasisVariants);
const iconButtonSlots = {
    buttonSlot: [
        'relative antialiased transition-colors duration-400 rounded-action-md cursor-pointer transition',
        'focus-visible:outline-2 group focus-visible:outline-offset-2 focus-visible:outline-actionPrimary-12',
        "after:content-[''] after:absolute  after:opacity-0"
    ],
    tapSpaceSlot: 'absolute opacity-0 bg-transparent',
    wrapperSlot: 'rounded-action-md flex items-center justify-center transition',
    iconSlot: 'transition'
};
const iconButtonShadowVariants = {
    true: {
        buttonSlot: 'shadow-sm hover:shadow-lg'
    }
};
const iconButtonDisabledVariants = {
    true: {
        buttonSlot: 'cursor-not-allowed shadow-none',
        wrapperSlot: 'cursor-not-allowed'
    }
};
const compoundVariants = {
    primary: [
        {
            type: 'primary',
            disabled: true,
            class: {
                wrapperSlot: 'bg-actionPrimary-2 group-hover:bg-actionPrimary-2',
                iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
            }
        },
        {
            type: 'primary',
            disabled: false,
            emphasis: 'regular',
            class: {
                wrapperSlot: 'group-hover:bg-actionPrimary-9 bg-actionPrimary-8',
                iconSlot: 'group-hover:text-actionPrimary-4 text-actionPrimary-3'
            }
        },
        {
            type: 'primary',
            emphasis: 'medium',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionPrimary-9 bg-actionPrimary-8',
                iconSlot: 'group-hover:text-actionPrimary-4 text-actionPrimary-3'
            }
        },
        {
            type: 'primary',
            emphasis: 'bold',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionPrimary-4 bg-actionPrimary-3',
                iconSlot: 'group-hover:text-actionPrimary-9 text-actionPrimary-8'
            }
        },
        {
            type: 'primary',
            emphasis: 'bold',
            disabled: true,
            class: {
                wrapperSlot: 'bg-actionPrimary-1/20 group-hover:bg-actionPrimary-1/20',
                iconSlot: 'text-actionPrimary-1/40 group-hover:text-actionPrimary-1/40'
            }
        }
    ],
    secondary: [
        {
            type: 'secondary',
            disabled: true,
            class: {
                wrapperSlot: 'bg-actionPrimary-2 group-hover:bg-actionPrimary-2',
                iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
            }
        },
        {
            type: 'secondary',
            disabled: false,
            emphasis: 'regular',
            class: {
                wrapperSlot: 'group-hover:bg-actionSecondary-9 bg-actionSecondary-8',
                iconSlot: 'group-hover:text-actionSecondary-4 text-actionSecondary-3'
            }
        },
        {
            type: 'secondary',
            emphasis: 'medium',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionSecondary-1 bg-actionSecondary-1/80',
                iconSlot: 'group-hover:text-actionSecondary-4 text-actionSecondary-3'
            }
        },
        {
            type: 'secondary',
            emphasis: 'bold',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionSecondary-9/40 bg-actionSecondary-8/20',
                iconSlot: 'group-hover:text-actionSecondary-9 text-actionSecondary-1'
            }
        },
        {
            type: 'secondary',
            emphasis: 'bold',
            disabled: true,
            class: {
                wrapperSlot: 'bg-actionSecondary-1/20 group-hover:bg-actionSecondary-1/20',
                iconSlot: 'text-actionSecondary-1/40 group-hover:text-actionSecondary-1/40'
            }
        }
    ],
    plainPrimary: [
        {
            type: 'plainPrimary',
            disabled: true,
            class: {
                wrapperSlot: 'group-hover:bg-transparent',
                iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
            }
        },
        {
            type: 'plainPrimary',
            emphasis: 'regular',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionPrimary-13/10',
                iconSlot: 'text-actionPrimary-8 group-hover:text-actionPrimary-9'
            }
        },
        {
            type: 'plainPrimary',
            emphasis: 'medium',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionPrimary-13/10',
                iconSlot: 'text-actionPrimary-8 group-hover:text-actionPrimary-9'
            }
        },
        {
            type: 'plainPrimary',
            emphasis: 'bold',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionPrimary-3/10 text-actionPrimary-3',
                iconSlot: 'group-hover:text-actionPrimary-3'
            }
        },
        {
            type: 'plainPrimary',
            emphasis: 'bold',
            disabled: true,
            class: {
                iconSlot: 'text-actionPrimary-1/40 group-hover:text-actionPrimary-1/40'
            }
        }
    ],
    plainSecondary: [
        {
            type: 'plainSecondary',
            disabled: true,
            class: {
                wrapperSlot: 'group-hover:bg-transparent',
                iconSlot: 'text-actionSecondary-6 group-hover:text-actionSecondary-6'
            }
        },
        {
            type: 'plainSecondary',
            emphasis: 'regular',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionSecondary-13/10',
                iconSlot: 'text-actionSecondary-13 group-hover:text-actionSecondary-4'
            }
        },
        {
            type: 'plainSecondary',
            emphasis: 'medium',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionSecondary-13/10',
                iconSlot: 'text-actionSecondary-13 group-hover:text-actionSecondary-4'
            }
        },
        {
            type: 'plainSecondary',
            emphasis: 'bold',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionSecondary-1/10 text-actionSecondary-1',
                iconSlot: 'group-hover:text-actionSecondary-1'
            }
        },
        {
            emphasis: 'bold',
            type: 'plainSecondary',
            disabled: true,
            class: {
                iconSlot: 'text-actionSecondary-1/40 group-hover:text-actionSecondary-1/40'
            }
        }
    ],
    penny: [
        {
            type: 'penny',
            active: true,
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionPrimary-13/10',
                iconSlot: 'text-penny-10 fill'
            }
        },
        {
            type: 'penny',
            active: true,
            disabled: true,
            class: {
                wrapperSlot: 'group-hover:bg-transparent',
                iconSlot: 'text-penny-10 fill'
            }
        },
        {
            type: 'penny',
            active: false,
            disabled: true,
            class: {
                wrapperSlot: 'group-hover:bg-transparent',
                iconSlot: 'text-penny-6 group-hover:text-penny-6'
            }
        },
        {
            type: 'penny',
            active: false,
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-actionPrimary-13/10',
                iconSlot: 'text-penny-10'
            }
        },
        {
            type: 'penny',
            emphasis: 'bold',
            active: true,
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-penny-2/20',
                iconSlot: 'text-pennyAccents-3 fill'
            }
        },
        {
            type: 'penny',
            emphasis: 'bold',
            active: true,
            disabled: true,
            class: {
                wrapperSlot: 'group-hover:bg-transparent',
                iconSlot: 'text-pennyAccents-3 fill'
            }
        },
        {
            type: 'penny',
            emphasis: 'bold',
            active: false,
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:bg-penny-2/20',
                iconSlot: 'text-pennyAccents-3'
            }
        },
        {
            type: 'penny',
            emphasis: 'bold',
            active: false,
            disabled: true,
            class: {
                wrapperSlot: 'group-hover:bg-transparent',
                iconSlot: 'text-penny-10 group-hover:text-penny-10'
            }
        }
    ],
    radialPrimary: [
        {
            type: 'radialPrimary',
            disabled: false,
            class: {
                wrapperSlot: 'shadow-penny-md inset-shadow-radialPrimary relative overflow-hidden before:absolute before:inset-0 before:bg-radialPrimary after:absolute after:inset-0 after:bg-radialPrimaryActive after:opacity-0 before:transition-opacity after:transition-opacity before:duration-300 after:duration-300 before:ease-in-out after:ease-in-out group-hover:after:opacity-100',
                iconSlot: 'z-2'
            }
        },
        {
            type: 'radialPrimary',
            disabled: false,
            class: {
                wrapperSlot: '',
                buttonSlot: 'text-actionPrimary-3 relative z-[1] bg-transparent active:scale-90'
            }
        },
        {
            type: 'radialPrimary',
            emphasis: 'regular',
            disabled: true,
            class: {
                buttonSlot: 'bg-neutral-3',
                iconSlot: 'text-actionSecondary-6'
            }
        },
        {
            type: 'radialPrimary',
            emphasis: 'medium',
            disabled: true,
            class: {
                buttonSlot: 'bg-neutral-3',
                iconSlot: 'text-actionSecondary-6'
            }
        },
        {
            type: 'radialPrimary',
            emphasis: 'bold',
            disabled: true,
            class: {
                buttonSlot: 'bg-glassRadial-bold text-actionPrimary-6/40 hover:text-actionPrimary-6/40 inset-shadow-glassRadial-bold'
            }
        }
    ],
    radialSecondary: [
        {
            type: 'radialSecondary',
            disabled: false,
            class: {
                iconSlot: 'z-2',
                buttonSlot: 'active:scale-90'
            }
        },
        {
            type: 'radialSecondary',
            emphasis: 'regular',
            disabled: false,
            class: {
                wrapperSlot: 'shadow-penny-md inset-shadow-radialPrimary transition-none',
                buttonSlot: 'text-primary-1 shadow-penny-sm relative z-[1] bg-transparent',
                iconSlot: 'transition-none'
            }
        },
        {
            type: 'radialSecondary',
            emphasis: 'medium',
            disabled: false,
            class: {
                wrapperSlot: 'shadow-penny-md inset-shadow-radialPrimary transition-none',
                buttonSlot: 'text-primary-1 shadow-penny-sm relative z-[1] bg-transparent',
                iconSlot: 'transition-none'
            }
        },
        {
            type: 'radialSecondary',
            emphasis: 'regular',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:text-primary-1 relative overflow-hidden before:absolute before:inset-0 before:bg-radialSecondary after:absolute after:inset-0 after:bg-radialSecondaryActive after:opacity-0 before:transition-opacity after:transition-opacity before:duration-300 after:duration-300 before:ease-in-out after:ease-in-out group-hover:after:opacity-100',
                buttonSlot: 'active:scale-90 text-primary-13 hover:shadow-penny-md'
            }
        },
        {
            type: 'radialSecondary',
            emphasis: 'medium',
            disabled: false,
            class: {
                wrapperSlot: 'group-hover:text-primary-1 relative overflow-hidden before:absolute before:inset-0 before:bg-radialSecondary after:absolute after:inset-0 after:bg-radialSecondaryActive after:opacity-0 before:transition-opacity after:transition-opacity before:duration-300 after:duration-300 before:ease-in-out after:ease-in-out group-hover:after:opacity-100',
                buttonSlot: 'active:scale-90 text-primary-13 hover:shadow-penny-md'
            }
        },
        {
            type: 'radialSecondary',
            emphasis: 'regular',
            disabled: true,
            class: {
                buttonSlot: 'bg-neutral-3 inset-shadow-glassRadial-bold',
                iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
            }
        },
        {
            type: 'radialSecondary',
            emphasis: 'medium',
            disabled: true,
            class: {
                buttonSlot: 'bg-neutral-3 inset-shadow-glassRadial-bold',
                iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
            }
        },
        {
            type: 'radialSecondary',
            disabled: false,
            emphasis: 'bold',
            class: {
                buttonSlot: 'bg-glassRadial-bold inset-shadow-glassRadial-bold'
            }
        },
        {
            type: 'radialSecondary',
            emphasis: 'bold',
            disabled: true,
            class: {
                buttonSlot: 'text-actionPrimary-6/40 hover:text-actionPrimary-6/40',
                iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
            }
        },
        {
            type: 'radialSecondary',
            emphasis: 'bold',
            disabled: false,
            class: {
                wrapperSlot: 'relative overflow-hidden before:absolute before:inset-0 before:bg-glassRadial-bold after:absolute after:inset-0 after:bg-radialSecondaryActive after:opacity-0 before:transition-opacity after:transition-opacity before:duration-300 after:duration-300 before:ease-in-out after:ease-in-out group-hover:after:opacity-100',
                buttonSlot: 'text-primary-1'
            }
        }
    ],
    plainFavorite: [
        {
            type: 'plainFavorite',
            active: true,
            disabled: false,
            class: {
                iconSlot: 'text-favorite-8 group-hover:text-favorite-9'
            }
        },
        {
            type: 'plainFavorite',
            active: false,
            disabled: false,
            class: {
                iconSlot: 'text-neutral-5 group-hover:text-neutral-6'
            }
        },
        {
            type: 'plainFavorite',
            disabled: true,
            class: {
                iconSlot: 'text-actionPrimary-6 group-hover:text-actionPrimary-6'
            }
        }
    ]
};
const iconButtonCompoundVariants = [
    ...compoundVariants.primary,
    ...compoundVariants.secondary,
    ...compoundVariants.plainPrimary,
    ...compoundVariants.plainSecondary,
    ...compoundVariants.plainFavorite,
    ...compoundVariants.penny,
    ...compoundVariants.radialPrimary,
    ...compoundVariants.radialSecondary,
    {
        shadow: true,
        disabled: true,
        class: {
            buttonSlot: 'shadow-none hover:shadow-none'
        }
    }
];
export { iconButtonCompoundVariants, iconButtonDisabledVariants, iconButtonEmphases, iconButtonEmphasisVariants, iconButtonShadowVariants, iconButtonSizeVariants, iconButtonSizes, iconButtonSlots, iconButtonTypeVariants, iconButtonTypes };
